import { PackageType } from "@/__generated__/globalTypes"
import useAuth from "@/components/auth/useAuth"
import React from "react"
import { Redirect, Route, RouteProps } from "react-router-dom"
import ModuleContext from "./ModuleContext"
import NoModule from "./NoModule"
import NoOrganisation from "./NoOrganisation"
// import ErrorBoundary from "@/components/util/error/ErrorBoundary"

export interface ModuleRouteProps extends RouteProps {
  module: "owner" | "manager" | "consultant"
  organisationPackage?: Partial<keyof typeof PackageType>
}

export function ModuleRoute(props: ModuleRouteProps) {
  const {
    component: Component,
    module,
    organisationPackage,
    children,
    ...rest
  } = props
  const { user } = useAuth()

  return (
    <Route
      {...rest}
      render={props => {
        if (!user) {
          // not logged in so redirect to login page with the return url
          return (
            <Redirect
              to={{ pathname: "/login", state: { from: props.location } }}
            />
          )
        }

        if (!user?.agreed)
          return (
            <Redirect
              to={{ pathname: "/register", state: { from: props.location } }}
            />
          )

        if (user?.password_reset)
          return (
            <Redirect
              to={{
                pathname: "/passwordreset",
                state: { from: props.location }
              }}
            />
          )

        //Check user belongs to an organisation
        if (!user.organisation) return <NoOrganisation />

        //Check if the organisation has the required module, ignore if no module specified
        if (
          (module &&
            (!user.organisation.modules ||
              !user.organisation.modules.includes(module))) ||
          (organisationPackage &&
            !user.organisation?.organisationPackages?.data.some(
              orgPackage => orgPackage?.type === organisationPackage
            ))
        )
          return <NoModule />

        if (children)
          // authorised so return component
          return (
            <ModuleContext.Provider value={{ module }}>
              {children}
            </ModuleContext.Provider>
          )

        if (Component)
          return (
            <ModuleContext.Provider value={{ module }}>
              <Component {...props} />
            </ModuleContext.Provider>
          )

        return null
      }}
    />
  )
}
